import axios from "axios";
let vtimer = null
export async function getfromApi(config) {
    axios(config).then(res => {
        this.defaultdata = res.data.data
    })
}
export function numformat(num, fix = 1) {
    // 将输入转换为数值
    let val = +num;
    // 处理非数值或无效输入
    if (isNaN(val)) {
        return '0'; // 或者根据需求返回其他默认值
    }
    const truncate = (value, fix) => {
        const factor = 10 ** fix;
        return Math.trunc(value * factor) / factor;
    };
    // 处理万，亿的数据，fix为保留的小数位数
    if (val > 100000000) {
        val = truncate(val / 100000000, fix)
        return val + '亿'
    } else if (val > 10000) {
        val = truncate(val / 10000, fix)
        return val + '万'
    } else {
        return truncate(val, fix)
    }
}
export function numformat2(num, fix = 0) {
    let val = +num
    if (isNaN(val)) {
        return 0
    }
    const truncate = (value, fix) => {
        const factor = 10 ** fix;
        return Math.trunc(value * factor) / factor;
    };
    return truncate(val, fix).toLocaleString()
}
// 初始化数据方法
export function setData() {
    clearInterval(vtimer)
    vtimer = null
    let vdatalist = []
    let { apiconfig, isApi, isExcel, exceldata, vdata, iscontact, valueMap } = this.scopedata
    apiconfig && (this.apiconfig = apiconfig)
    this.isApi = isApi
    this.isExcel = isExcel
    this.iscontact = iscontact
    exceldata && (this.exceldata = exceldata)
    if (this.isList) {
        valueMap && (this.valueMap = valueMap)
    }
    if (vdata && vdata.length) {
        vdatalist = vdata.filter(item => {
            let vlist = Object.keys(item)
            let isdata = false
            vlist.forEach(del => {
                if (item[del] == undefined) {
                    item[del] = ''
                } else if (del && item[del]) {
                    isdata = true
                }
            })
            if (vlist.length && isdata) return item
        })
    }
    if (vdatalist && vdatalist.length) {
        this.defaultdata = vdatalist
    }
    this.scope = JSON.stringify(this.scopedata)
    if (this.apiconfig && this.isApi) {
        if (this.apiconfig && this.apiconfig.iscontact && this.apiconfig.params.id) {
            this.getfromApi(this.apiconfig)
            if (+this.apiconfig.frequ > 0) {
                vtimer = setInterval(() => {
                    this.getfromApi(this.apiconfig)
                }, this.apiconfig.frequ * 1000)
            }
        } else if (!this.apiconfig.iscontact) {
            this.getfromApi(this.apiconfig)
            if (+this.apiconfig.frequ > 0) {
                vtimer = setInterval(() => {
                    this.getfromApi(this.apiconfig)
                }, this.apiconfig.frequ * 1000)
            }
        }
    }
}
// 数字跳动功能
export function rateNum(ref, max, fix = 0) {
    let dom = this.$refs[ref]
    if (!dom) {
        return max
    }
    let vmax = (+max).toFixed(fix).toString()
    let vtext = ''
    for (let i = 0;i < vmax.length; i++) {
        if (vmax[i] == '.') {
            vtext += '.'
        } else {
            vtext += '0'
        }
    }
    dom[0].innerHTML = vtext
    let timer = null
    timer = setInterval(() => {
        if (!dom[0] || dom[0].innerHTML == vmax || !dom[0]) {
            clearInterval(timer)
            timer = null
        } else {
            let nowlist = dom[0].innerHTML.split('')
            let maxlist = vmax.split('')
            nowlist.forEach((item, i) => {
                if (maxlist[i] == '.') {
                    
                }
                if (item != maxlist[i]) {
                    nowlist[i] = +item + 1
                }
            })
            nowlist = [...nowlist]
            dom[0].innerHTML = nowlist.join('')
        }
    }, 100);
}
// 生成要求范围内的随机整数
export function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}